import React from "react"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import * as positionHelper from "../../helpers/positionHelper"
import { IPosition, ELoggedInUserType } from "../../models"
import autobind from "class-autobind"
import _ from "lodash"
import { green500 } from "material-ui/styles/colors"
import AccountStore from "../../stores/AccountStore"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"

interface IProps {
    positionId: string
    positions: IPosition[]
    label: string
    disabled?: boolean
    style?: React.CSSProperties
    loggedInUserType?: ELoggedInUserType
    errorText?: string
    labelStyle?: React.CSSProperties
    iconStyle?: React.CSSProperties
    menuItemStyle?: React.CSSProperties
    floatingLabelStyle?: React.CSSProperties
    errorLabelFontSize?: number
    errorLabelBottomForPayInfo?: number
    errorLabelBottomForNonPayInfo?: number
    hidePayInfo?: boolean
    payInfoStyle?: React.CSSProperties
    floatingLabelFixed?: boolean
    onSave?(positionId: string): void
    showEmpty?: boolean
}
interface IState {
    selectedPositionId: string
}

export default class PositionSelector extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            selectedPositionId: props.positionId
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ selectedPositionId: nextProps.positionId })
    }

    handlePositionChange(event, index, value) {
        this.setState({ selectedPositionId: value })
        this.props.onSave(value)
    }

    render() {
        if (!this.props.showEmpty && (!this.props.positions || this.props.positions.length === 0)) return null
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        })
        const positions = _.cloneDeep(this.props.positions)
        let payInfo
        if (permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.ViewRates) && !this.props.hidePayInfo && this.props.positionId && this.props.positionId.length > 0) {
            const selectedPosition = positionHelper.getPositionFromId(this.props.positionId, positions)
            if (selectedPosition && selectedPosition.PayInfo) {
                payInfo = (
                    <div style={this.props.payInfoStyle ?
                        this.props.payInfoStyle :
                        { color: "#aaaaaa", fontSize: 12, position: "absolute", top: 63 }}
                    >
                        <strong>Pay Rate:</strong> {formatter.format(selectedPosition.PayInfo.PayRate)}
                        {this.props.loggedInUserType !== ELoggedInUserType.Employee && (
                            <span>
                                <strong style={{ marginLeft: 5 }}>Bill Rate:</strong> {formatter.format(selectedPosition.PayInfo.BillRate)}
                            </span>
                        )}
                    </div>
                )
            }
        }
        positions[0] !== null && positions.unshift(null)
        return (
            <div style={{ position: "relative" }}>
                {!(positions.length === 0) &&
                    <SelectField
                        data-intercom-target={"Select-Postion"}
                        autoWidth
                        title={this.state.selectedPositionId && this.props.positions && this.props.positions.length > 0 &&
                            this.props.positions.find(i => i.Id === this.state.selectedPositionId).Name
                        }
                        floatingLabelText={this.props.label}
                        value={this.state.selectedPositionId || this.props.positionId || null}
                        onChange={this.handlePositionChange}
                        disabled={this.props.disabled}
                        floatingLabelFixed={this.props.floatingLabelFixed}
                        style={this.props.style}
                        labelStyle={{ ...this.props.labelStyle, color: this.state.selectedPositionId === AccountStore.DiffPositionId && green500 }}
                        iconStyle={this.props.iconStyle ? this.props.iconStyle : { width: 40 }}
                        floatingLabelStyle={this.props.floatingLabelStyle}
                        errorText={this.props.errorText}
                        errorStyle={{
                            fontSize: this.props.errorLabelFontSize,
                            position: "absolute",
                            bottom: payInfo ?
                                this.props.errorLabelBottomForPayInfo ?
                                    this.props.errorLabelBottomForPayInfo :
                                    -20 :
                                this.props.errorLabelBottomForNonPayInfo ?
                                    this.props.errorLabelBottomForNonPayInfo :
                                    -10
                        }}
                    >
                        {positions.sort((a, b) => {
                            if (a == null || b == null) return -1
                            if (a.Id === AccountStore.DiffPositionId) return -1
                            if (b.Id === AccountStore.DiffPositionId) return 1
                            if (a.Name === b.Name) return 0
                            if (a.Name < b.Name) return -1
                            if (a.Name > b.Name) return 1
                        }).map((value, i) =>
                            <MenuItem
                                value={value && value.Id}
                                primaryText={value && value.Name}
                                key={i}
                                style={{ color: value && value.Id === AccountStore.DiffPositionId && green500 }}
                            />
                        )}
                    </SelectField>
                }
                {payInfo}
            </div>
        )
    }
}
